import { render, staticRenderFns } from "./ForgotUsername.vue?vue&type=template&id=1e29e738&scoped=true&"
import script from "./ForgotUsername.vue?vue&type=script&lang=ts&"
export * from "./ForgotUsername.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e29e738",
  null
  
)

export default component.exports